import { agentHomeRoute } from './agentRoutes'

/**
 * Page d'arrivée après connexion : l'accueil pour un admin ; pour un non-admin, directement la vue de son agent
 * quand il n'en a qu'un (rien à choisir sur la page des agents), la page des agents sinon.
 * Une redirection explicite (lien profond mémorisé par le guard) est respectée, sauf vers l'accueil.
 */
export function postLoginRoute(
  redirect: string | null | undefined,
  isAdmin: boolean,
  agents: readonly string[] = [],
): string {
  if (redirect && redirect !== '/') return redirect
  if (isAdmin) return '/'
  const onlyAgentRoute = agents.length === 1 ? agentHomeRoute(agents[0]) : null
  return onlyAgentRoute ?? '/agents'
}
